import { FC, useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PayrollConceptFragment } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { ConceptSelector } from 'modules/finance/components/FinancialWorkspace/components/ConceptSelector'

import { FinancialWorkspaceSettingsFormValues } from './constants'

interface ConceptsProps {
  title: string
  defaultConceptIds?: number[]
  field: keyof FinancialWorkspaceSettingsFormValues
  setExpensesConceptDetected?: (detected: boolean) => void
  setFieldValue: (
    field: keyof FinancialWorkspaceSettingsFormValues,
    value: number[] | boolean
  ) => void
  description?: string
}

export const Concepts: FC<ConceptsProps> = ({
  title,
  field,
  description,
  setFieldValue,
  defaultConceptIds,
  setExpensesConceptDetected,
}) => {
  const [selectedConcepts, setSelectedConcepts] = useState<PayrollConceptFragment[] | undefined>(
    undefined
  )

  const onValueChange = (concepts: PayrollConceptFragment[]) => {
    setFieldValue(
      field,
      concepts.map((o) => o.id)
    )
    setSelectedConcepts(concepts)
  }

  useUnsafeEffect(() => {
    if (selectedConcepts?.length && selectedConcepts?.some((o) => o.name === 'expenses')) {
      setExpensesConceptDetected?.(true)
    } else {
      setExpensesConceptDetected?.(false)
    }
  }, [selectedConcepts, setExpensesConceptDetected])

  return (
    <Box width="full" gap="s12">
      <Box gap="s2">
        <Text.Normal weight="medium" size="300">
          {title}
        </Text.Normal>
        {description && <Text.Normal size="200">{description}</Text.Normal>}
      </Box>
      <ConceptSelector
        mandatory
        label={title}
        filter={false}
        selectedConcepts={selectedConcepts}
        onValueChange={onValueChange}
        emptyLabel={i18n.t('finance.financial_workspace.settings.labor_cost.select_concepts')}
        alwaysOpen={false}
        defaultConceptIds={defaultConceptIds}
      />
    </Box>
  )
}
